export enum EstadoInputTextEnum {
  Padrao = ' ',
  Sucesso = 'mp-form-success',
  Alerta = 'mp-form-alert',
  Erro = 'mp-form-error',
  Preenchido = 'mp-form-filled',
}
